<mat-form-field #formFieldContainer  *ngIf="!deviceDetectService.detectMobile()" class="sc-drop-downdown-label">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>

  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    matTooltipPosition="left"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>

  <mat-select
              disableOptionCentering
              panelClass="ft-dropdown-center"
              [multiple]="isMultiple"
              [formControl]="formControl">
    <mat-option *ngIf="!isMultiple"></mat-option>
    <mat-option *ngFor="let option of optionArray" [value]="option">
      {{option}}
    </mat-option>
  </mat-select>
</mat-form-field>
<mat-form-field #formFieldContainer  *ngIf="deviceDetectService.detectMobile()" class="mobile-drop-down" [ngClass]="{'drop-down-class': isMultiple}" >
  <mat-label #labelContainer  (click)="toggleTooltip(tooltip)"
             class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <!--  Use native select element for mobile devices-->
  <select matNativeControl *ngIf="!isMultiple" [formControl]="formControl">
    <option value=""></option>
    <option [value]="option" *ngFor="let option of optionArray" >{{option}}</option>
  </select>
    <div  *ngIf="isMultiple" [ngClass]="{'dropdown': !disabled}">
      <input matNativeControl class="dropbtn form-control"  [readonly]="true" [formControl]="formValueControl">
      <div class="dropdown-content" id="{{registeredControlName}}" style="background: none;">
        <a href="javascript:void(0)" (click)="onClickEventDropDown($event)" *ngFor="let option of optionArray" >{{option}}</a>
      </div>
    </div>
</mat-form-field>
